/**
 * LR HUB posting tiers — derived purely from the member's approved,
 * non-deleted `hub_posts` count. Hub-isolated: no billing / verification
 * meaning whatsoever.
 *
 * 0–10 posts   → Silver Member
 * 11–50 posts  → Gold Member
 * 51+ posts    → Platinum Member
 */

export type HubTierKey = "silver" | "gold" | "platinum";

export interface HubTier {
  key: HubTierKey;
  label: string;
  /** Tailwind classes for the pill. */
  className: string;
  title: string;
}

export const HUB_TIERS: Record<HubTierKey, HubTier> = {
  silver: {
    key: "silver",
    label: "Silver Member",
    className: "border border-slate-300 bg-gradient-to-r from-slate-100 to-slate-50 text-slate-600",
    title: "Silver — under 11 posts on the LR Hub",
  },
  gold: {
    key: "gold",
    label: "Gold Member",
    className: "border border-amber-400/70 bg-gradient-to-r from-amber-100 to-amber-50 text-amber-800",
    title: "Gold — 11–50 posts on the LR Hub",
  },
  platinum: {
    key: "platinum",
    label: "Platinum Member",
    className:
      "border border-cyan-300 bg-gradient-to-r from-cyan-50 via-slate-50 to-cyan-100 text-cyan-800 shadow-[0_0_0_1px_rgba(34,211,238,0.25)]",
    title: "Platinum — 51+ posts on the LR Hub",
  },
};

export function hubTierForPosts(posts: number): HubTier {
  if (posts >= 51) return HUB_TIERS.platinum;
  if (posts >= 11) return HUB_TIERS.gold;
  return HUB_TIERS.silver;
}

/** "Member Since" short label, e.g. "Aug 2026". */
export function hubMemberSinceLabel(createdAt?: string | null): string {
  if (!createdAt) return "—";
  const d = new Date(createdAt);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("en-US", { month: "short", year: "numeric" });
}
